define('pages/laser-page',["require", "exports", "../baseline/lasers", "../charts/multichart", "../dom", "../maps/basemap", "../maps/layers/markerlayer", "../maps/layers/placeslayer", "../places/places", "../tracks/starred", "../tracks/track-enabled", "../util/http", "../views/text-setting"], function (require, exports, laserApi, multichart_1, dom_1, basemap_1, markerlayer_1, placeslayer_1, places, starred, trackEnabled, http_1, text_setting_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(laserId, userId) {
        // Load starred track data
        starred.init(userId);
        // Init profile chart
        var chart = new multichart_1.MultiChart();
        chart.update(); // Show axes while data is loading
        // Fetch laser
        laserApi.byId(laserId).then(function (laser) {
            trackEnabled.addLaser(laser);
            // Not all lasers have location, don't init map
            if (laser.lat !== undefined && laser.lng !== undefined) {
                var ll = { lat: laser.lat, lng: laser.lng, name: laser.name };
                var map_1 = new basemap_1.BaseMap({
                    center: ll,
                    zoom: 16
                });
                map_1.initGoogle(document.getElementById("map"));
                map_1.addLayer(new markerlayer_1.MarkerLayer([ll]));
                // Show nearby places
                places.getNearby(ll, userId).then(function (nearby) {
                    map_1.addLayer(new placeslayer_1.PlacesLayer(nearby));
                });
            }
            // Edit laser name
            var laserName = (0, dom_1.q)(".laser-name")[0];
            if (laserName) {
                new text_setting_1.TextSetting({
                    element: laserName,
                    selectMode: text_setting_1.TextSettingMode.SelectEnd,
                    closeOnBlur: true,
                    save: function (name) {
                        return (0, http_1.postJson)("/lasers/" + laserId + "/name", name);
                    }
                });
            }
            // Set onclick for delete button
            for (var _i = 0, _a = (0, dom_1.q)(".delete-button"); _i < _a.length; _i++) {
                var deleteButton = _a[_i];
                deleteButton.onclick = function () {
                    if (confirm("Delete laser profile " + laser.name + "? Profiles cannot be un-deleted.")) {
                        laserApi.deleteLaser(laser).then(function () {
                            window.location.href = "/users/" + userId + "/profiles";
                        });
                    }
                    return false;
                };
            }
        });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/pages/laser-page.js.map;
